import type { ReactNode } from 'react'

export const AUTH_CARD_CLASS =
  'flex w-full flex-col gap-6 rounded-lg border border-gray-200 bg-white px-8 py-9 shadow-sm'

/**
 * One card, centred, on a plain ground.
 *
 * The old layout gave half the viewport to a decorative gradient and pushed the
 * form into the right-hand column, where it sat off-centre with nothing to
 * anchor it. Nobody signing in needs the decoration, and on a wide monitor the
 * form ended up further from the eye than the empty half was. This puts the one
 * thing the page is for in the middle of it — for every step of signing in.
 */
export function AuthScreen({ children }: { children: ReactNode }) {
  return (
    <main className="bg-warm-25 flex min-h-full items-center justify-center px-6 py-12">
      <div className="w-full max-w-100">
        {children}
        <p className="mt-6 text-center text-xs text-gray-500">
          Platform console · authorised operators only
        </p>
      </div>
    </main>
  )
}

export function AuthCardHeader({ title, subtitle }: { title: string; subtitle: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-4 text-center">
      <img src="/logo.png" alt="TheCarGo" className="h-8 w-auto" />
      <div className="flex flex-col gap-1">
        <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
        <p className="text-label text-gray-500">{subtitle}</p>
      </div>
    </div>
  )
}
